/**
 *  Функция декоратор. Добовляет к элементам текущей корзины булевое значение в стоп листе он или нет
 * @function isInStopList
 * @param {array} stopList - стоп лист из выбранного ресторана
 * @param {array} composition - текущая корзина товаров
 * @returns {composition}
 */
export default function isInStopListDecorator(stopList, composition) {
  if (!stopList?.length) {
    return composition;
  }

  return composition.map(element => {
    const elementInStopList = stopList.find(stopListItem => {
      if (element.type === 'combo') {
        return stopListItem.combo_box === element.item.combo_box_id;
      }
      // для обычного товара проверка идет через item.id
      // для бесплатных соусов проверка через .id
      if (element.item) {
        return stopListItem.good === element.item.id;
      }

      return stopListItem.good === element.id;
    });

    return elementInStopList
      ? { ...element, isInStopList: true, replacements: elementInStopList.replacements }
      : element;
  });
}
